import { render, staticRenderFns } from "./NHScoreTable.vue?vue&type=template&id=62de9a06&"
import script from "./NHScoreTable.vue?vue&type=script&lang=js&"
export * from "./NHScoreTable.vue?vue&type=script&lang=js&"
import style0 from "./NHScoreTable.vue?vue&type=style&index=0&id=62de9a06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports